import {
  HttpHeaders,
  HttpClient,
  HttpErrorResponse,
} from '@angular/common/http';
import { Injectable } from '@angular/core';
import { throwError } from 'rxjs';
import { catchError } from 'rxjs/internal/operators/catchError';
import { environment } from 'src/environments/environment';
import { Labreport } from '../Models/labreport.model';

@Injectable({
  providedIn: 'root',
})
export class LabreportService {
  url = environment.Url + 'LabReports';
  labTest = environment.Url + 'LabReports/labTest';

  imgUrl = environment.Url + 'ImageUpload';

  header = new HttpHeaders({
    Authorization: 'token' + localStorage.getItem('token'),
  });

  constructor(private http: HttpClient) {}

  imageUpload(body) {
    return this.http.post(this.imgUrl, body);
  }

  registerLabReport(body) {
    return this.http
      .post<Labreport>(this.url, body)
      .pipe(catchError(this.handleError));
  }

  getLabReports() {
    return this.http
      .get<Labreport[]>(this.url)
      .pipe(catchError(this.handleError));
  }
  getLabReportById(id) {
    return this.http.get<Labreport>(this.url + '/' + id);
  }
  getLabTest(id) {
    return this.http.get<Labreport>(this.labTest + '/' + id);
  }

  updateLabReport(id, body) {
    return this.http
      .put<Labreport>(this.url + '/' + id, body)
      .pipe(catchError(this.handleError));
  }

  deleteLabReport(id) {
    return this.http
      .delete<Labreport>(this.url + '/' + id)
      .pipe(catchError(this.handleError));
  }

  private handleError(error: HttpErrorResponse) {
    if (error.error instanceof ErrorEvent) {
      // A client-side or network error occurred. Handle it accordingly.
      console.error('An error occurred:', error.error.message);
    } else {
      // The backend returned an unsuccessful response code.
      // The response body may contain clues as to what went wrong,
      if (error.status == 400) {
        console.log(error.error);
        return throwError(error.error);
      } else if (error.status == 401) {
        return throwError('invalid username or password');
      } else if (error.status == 0) {
        return throwError('network failure please try again later ');
      }
      return throwError(
        `Backend returned code ${error.status}, ` + `body was: ${error.error}`
      );
    }
    // return an observable with a user-facing error message
    return throwError('Something bad happened; please try again later.');
  }
}
